<template>
  <div>
    <router-view />
  </div>
</template>
<script>
export default {
  data() {
    return {

    }
  }
}
</script>
<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/view/solution/index.vue